export default "__VITE_ASSET__CX3Ak1zj__"